export default __webpack_public_path__ + "static/media/img16.4ce86263.jpg";